import React from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Mail, Lock, User, Phone, UserPlus } from "lucide-react";

export default function Register() {
  const { register: registerAuth } = useAuth();
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm();

  const onSubmit = async (data) => {
    const success = await registerAuth(data.name, data.email, data.password, data.phone);
    if (success) navigate("/booking");
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Join masterclass</h2>
        <p>Create an account to reserve your seat</p>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={`input-field ${errors.name ? 'error-border' : ''}`}>
            <User size={18} />
            <input 
              {...register("name", { required: "Full Name is required", minLength: { value: 3, message: "Name too short" } })}
              placeholder="Full Name" 
            />
          </div>
          {errors.name && <span className="error-text">{errors.name.message}</span>}

          <div className={`input-field ${errors.email ? 'error-border' : ''}`}>
            <Mail size={18} />
            <input 
              type="email" 
              {...register("email", { 
                required: "Email is required", 
                pattern: { value: /^\S+@\S+$/i, message: "Invalid email" } 
              })}
              placeholder="Email Address" 
            />
          </div>
          {errors.email && <span className="error-text">{errors.email.message}</span>}

          <div className={`input-field ${errors.phone ? 'error-border' : ''}`}>
            <Phone size={18} />
            <input 
              {...register("phone", { 
                required: "Phone number is required",
                pattern: { value: /^[0-9+]{10,15}$/, message: "Invalid phone number" }
              })}
              placeholder="Phone Number" 
            />
          </div>
          {errors.phone && <span className="error-text">{errors.phone.message}</span>}

          <div className={`input-field ${errors.password ? 'error-border' : ''}`}>
            <Lock size={18} />
            <input 
              type="password" 
              {...register("password", { 
                required: "Password is required",
                minLength: { value: 6, message: "Minimum 6 characters" }
              })}
              placeholder="Password" 
            />
          </div>
          {errors.password && <span className="error-text">{errors.password.message}</span>}

          <button type="submit" className="auth-btn" disabled={isSubmitting}>
            <UserPlus size={18} /> {isSubmitting ? "Registering..." : "Register"}
          </button>
        </form>

        <p className="auth-footer">
          Already have an account? <Link to="/login">Login Now</Link>
        </p>
      </div>
    </div>
  );
}

